export function execFunction(fn, ...args) {
    if (typeof fn === "function") {
        return fn(args);
    }
}
//# sourceMappingURL=ExecFunction.js.map